/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import Util from '../../../../util/Util';
import {
  ButtonElement,
  ButtonType,
  DescriptionElement,
  IdxStepTransformer,
  TitleElement,
} from '../../types';
import { loc } from '../../util';

export const transformExpiredCustomPassword: IdxStepTransformer = ({
  transaction,
  formBag,
}) => {
  const { uischema } = formBag;
  const {
    nextStep: {
    // @ts-expect-error OKTA-598703 - customExpiredPasswordName does not exist in NextStep type
      customExpiredPasswordName,
      // @ts-expect-error OKTA-598703 - customExpiredPasswordURL does not exist in NextStep type
      customExpiredPasswordURL,
    },
  } = transaction;

  const titleElement: TitleElement = {
    type: 'Title',
    options: {
      content: loc('password.expired.title.generic', 'login'),
    },
  };

  const subtitleElement: DescriptionElement = {
    type: 'Description',
    contentType: 'subtitle',
    options: {
      content: loc('password.expired.custom.subtitle', 'login'),
    },
  };

  const submitBtnElement: ButtonElement = {
    type: 'Button',
    label: loc('password.expired.custom.submit', 'login', [customExpiredPasswordName]),
    options: {
      type: ButtonType.BUTTON,
      step: transaction.nextStep!.name,
      onClick: () => Util.redirect(customExpiredPasswordURL),
    },
  };

  uischema.elements = [
    titleElement,
    subtitleElement,
    submitBtnElement,
  ];

  return formBag;
};
